import {defineStore} from "pinia";
import {
    EModalId,
    type ModalApontamentoCadastro,
    type ModalApontamentoLista,
    type ModalCadastroEmpresa,
    type ModalClienteAlteracao,
    type ModalClienteCadastro,
    type ModalClienteEndereco,
    type ModalColaboradorEmpresa,
    type ModalColaboradorEmpresaAdicionar,
    type ModalEmpresaAlteracao,
    type ModalEmpresasDoColaborador,
    type ModalEmptyComponent,
    type ModalEnderecoCadastro,
    type ModalExportTableSelectColumns,
    type ModalGrupoPermissaoCadastro,
    type ModalPlanoSeguroAlteracao,
    type ModalPlanoSeguroCadastro,
    type ModalSeguroCadastro,
    type ModalSelecaoPagamentoVenda,
    type ModalSelecaoPlanoSeguroVenda,
    type ModalSelecaoProdutoVenda,
    type ModalSinistroCadastro,
    type ModalUsuarioColaboradorCadastro,
    type ModalVendaCadastro,
    type ModalVendaPagamentoLista,
    type ModalVendaProdutoLista,
    type ModalLancamentoCadastro,
    type ModalLancamentoAlteracao,
    type ModalLancamentoPago,
    type ModalComissaoCadastro,
    type ModalComissaoAlteracao,
    type ModalMetaVendaCadastro,
    type ModalMetaVendaAlteracao,
    type ModalFormaPagamentoTarifaCadastro,
    type ModalEmpresaDescontoCadastro,
    type ModalEmpresaDescontoAlteracao,
    type ModalAutorizacaoCodigo,
    type ModalEmpresaDescontoColaboradorCadastro,
    type ModalItemClienteLista,
    type ModalItemClienteCadastro
} from "@/domain/type/modal.type";

import lodash from 'lodash';

class ModalComponent<Type> {
    readonly modalId: EModalId;
    private param: Type | any = null;
    private isParamSetted = false;

    constructor(modalId: EModalId) {
        this.modalId = modalId;
        this.param = null;
    }

    /*
        Para garantis que os parametros setados sejam lidos uma unica vez,
        sempre que os parametros for definido a variavel isParamSetted sera marcada como TRUE.

        Ao obter os parametros, sera verificar se a variabel isParamSetted eh TRUE, se for, ela sera marcada como FALSE
        e o valor dos parametros retornado.

        Caso a variavel seja false sera retornado NULL
     */


    //Metodo para atribuir o parametro ao modal
    public setParam(param: any) {
        this.param = param;

        //Verifica se ha parametros que precisam ser copiados de forma profunda (DEEP COPY ou DEEP CLONE)
        if (this.param?.deepParams) {
            this.param.deepParams = lodash.cloneDeep(param.deepParams);
        }
        this.isParamSetted = true;
    }

    //Metodo para retornar o valor|objeto do parametro

    public getParam(): Type | null {

        if (!this.isParamSetted) return null;
        this.isParamSetted = false;

        //Verifica se existe parametro
        if (!this.param) return null;

        //Retorna os parametros
        return this.param as Type;
    }


}


export const useModalStore = defineStore("modalStore", () => {

    //Cadastra os modais
    const arrModaisCadastrados = [
        new ModalComponent<ModalEmptyComponent>(EModalId.modalEmptyComponent),
        new ModalComponent<ModalExportTableSelectColumns>(EModalId.modalExportTableSelectColumns),


        new ModalComponent<ModalApontamentoLista>(EModalId.modalApontamentoLista),
        new ModalComponent<ModalApontamentoCadastro>(EModalId.modalApontamentoCadastro),
        new ModalComponent<ModalUsuarioColaboradorCadastro>(EModalId.modalUsuarioColaboradorCadastro),
        new ModalComponent<ModalColaboradorEmpresa>(EModalId.modalColaboradorEmpresa),
        new ModalComponent<ModalColaboradorEmpresaAdicionar>(EModalId.modalColaboradorEmpresaAdicionar),
        new ModalComponent<ModalEmpresasDoColaborador>(EModalId.modalEmpresasDoColaborador),

        new ModalComponent<ModalGrupoPermissaoCadastro>(EModalId.modalGrupoPermissaoCadastro),

        new ModalComponent<ModalCadastroEmpresa>(EModalId.modalEmpresaCadastro),
        new ModalComponent<ModalEmpresaAlteracao>(EModalId.modalEmpresaAlteracao),

        new ModalComponent<ModalClienteCadastro>(EModalId.modalClienteCadastro),
        new ModalComponent<ModalClienteAlteracao>(EModalId.modalClienteAlteracao),

        new ModalComponent<ModalItemClienteLista>(EModalId.modalItemClienteLista),
        new ModalComponent<ModalItemClienteCadastro>(EModalId.modalItemClienteCadastro),


        new ModalComponent<ModalClienteAlteracao>(EModalId.modalClienteAlteracao),
        new ModalComponent<ModalClienteEndereco>(EModalId.modalClienteEndereco),

        new ModalComponent<ModalPlanoSeguroCadastro>(EModalId.modalPlanoSeguroCadastro),
        new ModalComponent<ModalPlanoSeguroAlteracao>(EModalId.modalPlanoSeguroAlteracao),

        new ModalComponent<ModalEnderecoCadastro>(EModalId.modalEnderecoCadastro),

        new ModalComponent<ModalSeguroCadastro>(EModalId.modalSeguroCadastro),
        new ModalComponent<ModalSinistroCadastro>(EModalId.modalSinistroCadastro),

        new ModalComponent<ModalLancamentoCadastro>(EModalId.modalLancamentoCadastro),
        new ModalComponent<ModalLancamentoAlteracao>(EModalId.modalLancamentoAlteracao),
        new ModalComponent<ModalLancamentoPago>(EModalId.modalLancamentoPago),

        new ModalComponent<ModalSelecaoProdutoVenda>(EModalId.modalSelecaoProdutoVenda),
        new ModalComponent<ModalSelecaoPagamentoVenda>(EModalId.modalSelecaoPagamentoVenda),
        new ModalComponent<ModalSelecaoPlanoSeguroVenda>(EModalId.modalSelecaoPlanoSeguroVenda),
        new ModalComponent<ModalVendaPagamentoLista>(EModalId.modalVendaPagamentoLista),
        new ModalComponent<ModalVendaProdutoLista>(EModalId.modalVendaProdutoLista),

        new ModalComponent<ModalVendaCadastro>(EModalId.modalVendaCadastro),

        new ModalComponent<ModalComissaoCadastro>(EModalId.modalComissaoCadastro),
        new ModalComponent<ModalComissaoAlteracao>(EModalId.modalComissaoAlteracao),

        new ModalComponent<ModalMetaVendaCadastro>(EModalId.modalMetaVendaCadastro),
        new ModalComponent<ModalMetaVendaAlteracao>(EModalId.modalMetaVendaAlteracao),

        new ModalComponent<ModalEmpresaDescontoCadastro>(EModalId.modalEmpresaDescontoCadastro),
        new ModalComponent<ModalEmpresaDescontoAlteracao>(EModalId.modalEmpresaDescontoAlteracao),

        new ModalComponent<ModalFormaPagamentoTarifaCadastro>(EModalId.modalFormaPagamentoTarifaCadastro),
        new ModalComponent<ModalAutorizacaoCodigo>(EModalId.modalAutorizacaoCodigo),
        new ModalComponent<ModalEmpresaDescontoColaboradorCadastro>(EModalId.modalEmpresaDescontoColaboradorCadastro),


    ];

    //funcao para recuperar um modal cadastrado
    function getModal(modalId: EModalId) {
        return arrModaisCadastrados.find(m => m.modalId == modalId);

    }


    return {getModal}
})


